import ShareableLinkCreated from './ShareableLinkCreated.component';

export default ShareableLinkCreated;